import { EntityIconType, EntityToneMap } from '@common/Entity/constants';
import { Entity } from '@common/types/Entity';
import { ChevronDownIcon, ChevronRightIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Badges, Button, Checkbox, Ellipsis, Tooltip, Indicator, overlayStyle, Stack } from '@prophecy/ui-v3';
import React from 'react';

import { StyledEntityheading } from '../styled';
import { getBaseEntityIcon } from '../utils';

export const EntityHeading = ({
  title,
  entity,
  hasToggle,
  toggle,
  actions,
  onChange,
  transpiled,
  enabled,
  checkboxDisabled = false
}: {
  title: string;
  transpiled?: boolean;
  entity: EntityIconType;
  hasToggle: boolean;
  checkboxDisabled?: boolean;
  actions?: React.ReactNode;
  toggle: () => void;
  enabled?: boolean;
  onChange: (value: string | boolean, key: string) => void;
}) => {
  const isPipeline = entity === Entity.Pipeline;
  const { icon, color } = getBaseEntityIcon(entity, 'm');
  return (
    <Stack width='100%' align='space-between' gap={theme.spaces.x12} direction='horizontal' alignY='center'>
      <Stack gap={theme.spaces.x12} direction='horizontal' alignY='center'>
        <Button
          onClick={toggle}
          variant='tertiaryGray'
          size='s'
          icon={hasToggle ? <ChevronDownIcon type='default' size='m' /> : <ChevronRightIcon type='default' size='m' />}
          aria-label={hasToggle ? `Collapse ${title}` : `Expand ${title}`}
          data-test-id='entity-heading-toggle-button'
        />
        {checkboxDisabled ? null : (
          <Checkbox
            checked={enabled}
            onChange={(checked) => onChange(checked, 'enabled')}
            aria-label={`${title} enabled`}
          />
        )}
        <Badges tone={EntityToneMap[entity]} variant='pillLight' icon={icon} iconPlacement='left'>
          <StyledEntityheading level='sm15' tone={color}>
            <Ellipsis tooltip={true} tooltipProps={{ overlayStyle }}>
              {title}
            </Ellipsis>
          </StyledEntityheading>
        </Badges>
        {transpiled && (
          <Tooltip
            title={`Transpilation completed for this ${entity}. ${
              isPipeline ? 'Configuration can be generated for transpiled pipelines.' : ''
            }`}>
            <span>
              <Indicator data-test-id='transpiler-import-entity-heading-indicator' />
            </span>
          </Tooltip>
        )}
      </Stack>
      {actions}
    </Stack>
  );
};
